export default __webpack_public_path__ + "static/nfl-8e8b7a14ca215185acd7e6175a787249.png";